var _g, _path, _path2, _path3, _path4, _path5, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNumberDesligado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1505_2121)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 22.5,
    r: 21.5,
    fill: "#262729"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9785 28.431H36.2335V27.685H29.9785V28.431Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9785 28.431H36.2335V27.685H29.9785V28.431Z",
    stroke: "#979797",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.34 13.1251H8.125V14.0301H36.34C37.089 14.0301 37.698 14.6391 37.698 15.3881V16.0421V16.7451V17.6501V20.3651V21.2701V30.7731C37.698 31.5221 37.089 32.1311 36.34 32.1311H8.125V33.0361H36.34C37.588 33.0361 38.603 32.0211 38.603 30.7731V15.3881C38.603 14.1401 37.588 13.1251 36.34 13.1251",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.34 13.1251H8.125V14.0301H36.34C37.089 14.0301 37.698 14.6391 37.698 15.3881V16.0421V16.7451V17.6501V20.3651V21.2701V30.7731C37.698 31.5221 37.089 32.1311 36.34 32.1311H8.125V33.0361H36.34C37.588 33.0361 38.603 32.0211 38.603 30.7731V15.3881C38.603 14.1401 37.588 13.1251 36.34 13.1251Z",
    stroke: "#979797",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1505_2121",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 13,
    width: 31,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 33.161H38.728V13H8V33.161Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1505_2121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6079 22.5617V21.0655H21.8332V22.7585H25.4293L23.6181 25.1209L24.3137 26.1708H24.7074C25.6393 26.1708 26.1774 26.6696 26.1774 27.4177C26.1774 28.192 25.6393 28.6645 24.7074 28.6645C23.8675 28.6645 23.3294 28.3101 23.1063 27.6014L21.5576 28.4938C22.0695 29.7669 23.2769 30.4362 24.7074 30.4362C25.6261 30.4362 26.4005 30.1738 27.0304 29.6357C27.6735 29.0976 27.9885 28.3626 27.9885 27.4177C27.9885 26.1183 27.1354 25.1603 25.8886 24.7928L27.6079 22.5617Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.868 30.2525V28.507H17.4163L19.2143 26.7089C20.2249 25.6984 20.7236 24.7272 20.7236 23.7691C20.7236 22.8898 20.4217 22.1811 19.8311 21.6692C19.2405 21.1442 18.5187 20.8817 17.6919 20.8817C16.3926 20.8817 15.2376 21.5642 14.6602 22.8241L16.1826 23.7166C16.5107 22.9948 17.0225 22.6404 17.7181 22.6404C18.4137 22.6404 18.9124 23.1129 18.9124 23.8347C18.9124 24.3203 18.5581 24.9372 17.8625 25.6721L14.7258 28.9007V30.2525H20.868Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26953 21.9186L9.71576 23.4672L11.4482 22.9816V30.2525H13.2593V21.0655H11.6844L9.26953 21.9186Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1505_2121",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1505_2121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1505_2121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNumberDesligado);
export default __webpack_public_path__ + "static/media/Add_number_desligado.a5ff191ae4ec8b2a78f1d1e740562806.svg";
export { ForwardRef as ReactComponent };